module.exports = __webpack_public_path__ + "img/banner_movil2.ba65fb29.jpg";